export const mapToggleHelper = {
  open: 'open',
  closed: 'closed',
} as const;
